module.exports = __webpack_public_path__ + "img/integratedMarketing_5.f147a0ae.png";